import _ from "lodash";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { TextInput } from "react-spark";

import {
  withValidationOutputDefaultProps,
  withValidationOutputPropTypes,
  sharedFormInputPropTypes,
  sharedFormInputDefaultProps
} from "../hocs/prop-types";
import { withValidation } from "../hocs/WithValidation";

class InputField extends Component {
  componentDidMount() {
    this.props.context.registerFormElement({
      value: this.props.value,
      name: this.props.name,
      valid: this.props.validateOnRegisterUpdate.apply(this),
      validate: this.props.handleValidation,
      handleChange: this.props.handleChange,
      dependentFields: this.props.dependentFields
    });
  }

  componentDidUpdate() {
    const { name , value} = this.props;
    this.props.context.updateFormElement({
      value,
      name,
      valid: this.props.validateOnRegisterUpdate.apply(this)
    });
  }

  componentWillUnmount() {
    this.props.context.deregisterFormElement({
      name: this.props.name,
    }, this);
  }

  handleChanges(event) {
    const {context, handleChange, changeCallback} = this.props;

    handleChange(event, context);

    // for password confirmation and beyond
    if (changeCallback) {
      changeCallback(event);
    }
  }

  handleBlur(event) {
    const {context, handleBlur, blurCallback} = this.props;

    handleBlur(event, context.handleChange);

    // for password confirmation and beyond
    if (blurCallback) {
      blurCallback(event);
    }
  }

  handlePaste(event) {
    if(this.props.context && this.props.context.addPField) {
      this.props.context.addPField(event.target.name);
    }
  }

  render() {
    const {
      id,
      name,
      type,
      focusCallback,
      placeholder,
      disabled,
      errorMessage,
      className,
      hideLabel,
      helper,
      value,
      maxLength
    } = this.props;

    return (
      <TextInput
        className={className}
        disabled={disabled}
        error={errorMessage}
        id={id}
        label={hideLabel ? "" : placeholder}
        name={name}
        onChange={event => this.handleChanges(event)}
        onFocus={event => focusCallback && focusCallback(event)}
        onBlur={event => this.handleBlur(event)}
        onPaste={event => this.handlePaste(event)}
        type={type}
        helper={helper}
        value={value}
        maxLength={maxLength}
      />
    );
  }
}

InputField.defaultProps = {
  ...withValidationOutputDefaultProps,
  ...sharedFormInputDefaultProps,
  type: "text",
  value: "",
  changeCallback: undefined,
  focusCallback: undefined,
  blurCallback: undefined
};

InputField.propTypes = {
  ...withValidationOutputPropTypes,
  ...sharedFormInputPropTypes,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string,
  changeCallback: PropTypes.func,
  focusCallback: PropTypes.func,
  blurCallback: PropTypes.func
};

export default withValidation(InputField);
